import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Project } from '@leverege/api-redux';
import { NumericInput, Label, Selector, TextInput, Text } from '@leverege/ui-elements';
import ImageInput from './ImageInput';
import S from './InstallationDetails.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class InstallGateway extends React.Component {
  render() {
    const {
      powerSourceEnum,
      powerSource,
      RSSI,
      placementNotes,
      image,
      onChange
    } = this.props;
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx("hr", {
        className: classnames(S.bar)
      }), /*#__PURE__*/_jsx(Label, {
        variant: "detailValue",
        children: "Power Source (required)"
      }), /*#__PURE__*/_jsx(Selector, {
        variant: "small",
        value: powerSource,
        values: powerSourceEnum.values,
        valueKey: "value",
        nameKey: "name",
        onChange: onChange,
        eventData: "powerSource"
      }), /*#__PURE__*/_jsx(Label, {
        variant: "detailValue",
        children: "RSSI Threshold (optional)"
      }), /*#__PURE__*/_jsx(NumericInput, {
        onChange: onChange,
        value: RSSI,
        variant: "scan",
        eventData: "RSSI"
      }), /*#__PURE__*/_jsx(Label, {
        variant: "detailValue",
        children: "Installation Image (required)"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "detailLabel",
        children: "Upload an image that shows where the gateway has been installed"
      }), /*#__PURE__*/_jsx(ImageInput, {
        image: image,
        onChange: onChange
      }), /*#__PURE__*/_jsx(Label, {
        variant: "detailValue",
        children: "Placement Notes (required)"
      }), /*#__PURE__*/_jsx(TextInput, {
        eventData: "placementNotes",
        onChange: onChange,
        value: placementNotes
      })]
    });
  }
}
export default connect(state => ({
  ui: state.ui,
  powerSourceEnum: Project(window.Molten.getConfig('api/projectId')).enum('powerSource').getEnum(state)
}))(InstallGateway);